<template>
  <el-dialog
    :title="$t('button.uploadImg')"
    :visible.sync="dialogAddClient"
    :before-close="doClose"
    width="60%"
    top="5vh"
  >
    <el-form :ref="refForm" :rules="rules" :model="imageForm" label-width="160px">
      <el-row :gutter="24">
        <el-col :xs="24">
          <el-form-item prop="name" :label="$t('title.Imgtitle')">
            <el-input v-model="imageForm.name" style="width: 70%; min-width: 200px"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24">
          <el-form-item :label="$t('title.Image')" prop="image">
            <el-upload
              ref="uploadImage"
              class="upload-demo"
              action="#"
              :auto-upload="false"
              :show-file-list="false"
              :limit="limit"
              :on-change="onChange"
              :on-exceed="exceedFile"
              :before-upload="onBeforeUpload"
              :on-remove="remove"
              accept="image/*"
            >
              <el-button size="small" type="primary">{{$t("button.upload")}}</el-button>

              <div slot="tip">
                <img
                  :src="imageForm.imageUrl"
                  alt
                  style="max-width:80px;max-height: 80px;"
                  name="avatar"
                />
              </div>
              <!-- <div slot="tip" class="el-upload__tip">
                只能上传jpg/png文件，且不超过500kb
              </div>-->
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="brandCode"
            :label="$t('title.brand')"
            :rules="[{ required: true, message: this.$t('desc.select'), trigger: 'change' }]"
          >
            <el-select
              v-model="imageForm.brandCode"
              :placeholder="$t('desc.select')"
              style="width: 100%"
              clearable
            >
              <el-option
                :label="brandInfo.brandName"
                :value="brandInfo.brandCode"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24">
          <el-form-item>
            <el-button type="success" @click="onSubBtn(refForm)">{{$t("button.confirm")}}</el-button>
            <el-button @click="doClose">{{$t("button.cancel")}}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-dialog>
</template>
<script>
export default {
  name: "index",
  props: {
    refForm: "",
    isAdd: true,
    subButtonAuth: false,
    imageForm: {
      name: "",
      file: "",
      imageUrl: "",
      id: "",
      brandCode: "",
      brandList: []
    },

    limit: 1,
    dialogAddClient: false,
    title: "",
    brandInfo:{},
  },
  async mounted() {},
  data() {
    return {
      cascaderKey: 1,
      rules: {
        brandCode:[{required:true, message: this.$t('tips.needed'), trigger: ['blur','change']}],
        name: [
          { required: true, message: this.$t("tips.needed"), trigger: "blur" }
        ]
      },
      fileList: [],

      image: ""
    };
  },
  methods: {
    onSubBtn(value) {
      var that = this;
      if (this.imageForm.imageUrl == "") {
        this.$message({
          showClose: true,
          message: this.$t("tips.needed"),
          type: "error"
        });
        return false;
      }

      this.$refs[value].validate(valid => {
        if (valid) {
          that.fileList = [];
          that.image = "";
          this.$emit("onSubBtn", true);
        } else {
          return false;
        }
      });
    },
    doClose() {
      this.$emit("dialogVisibleEvent", false);
      this.$refs[this.refForm].resetFields();
    },
    onSubmit() {},
    exceedFile(files, fileList) {
      this.$notify.warning({
        title: "警告",
        message: `只能选择 ${this.limitNum} 个文件，请先删除文件后重新选择`
      });
    },
    onChange(file) {
      var that = this;
      var file = file.raw;
      this.imageForm.file = file;
      this.image = file.name;
      let reader = new FileReader();
      reader.onload = e => {
        //压缩图片并存到fileItem中
        this.getBase64(e.target.result).then(url => {
          that.imageForm.imageUrl = url;
          //this.$set(fileItem, 'src', url)
        });
      };
      reader.readAsDataURL(file);
    },
    remove(file) {},
    getBase64(url) {
      let self = this;
      let Img = new Image(),
        dataURL = "";
      Img.src = url;
      let p = new Promise(function(resolve, reject) {
        Img.onload = function() {
          //要先确保图片完整获取到，这是个异步事件
          let canvas = document.createElement("canvas"), //创建canvas元素
            width = Img.width, //确保canvas的尺寸和图片一样
            height = Img.height;
          // 默认将长宽设置为图片的原始长宽，这样在长宽不超过最大长度时就不需要再处理
          let ratio = width / height,
            maxLength = 1000,
            newHeight = height,
            newWidth = width;
          // 在长宽超过最大长度时，按图片长宽比例等比缩小
          if (width > maxLength || height > maxLength) {
            if (width > height) {
              newWidth = maxLength;
              newHeight = maxLength / ratio;
            } else {
              newWidth = maxLength * ratio;
              newHeight = maxLength;
            }
          }
          canvas.width = newWidth;
          canvas.height = newHeight;
          canvas.getContext("2d").drawImage(Img, 0, 0, newWidth, newHeight); //将图片绘制到canvas中
          dataURL = canvas.toDataURL("image/jpeg", 0.5); //转换图片为dataURL
          resolve(dataURL);
        };
      });
      return p;
    },
    onBeforeUpload(file) {
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
    }
  }
};
</script>
